import React from 'react';
import './textMon.scss';


interface IPodTextProps {
    text?: string;
    type?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4';
    className ?:string;
  }
  
  export const MonTextS75W500 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s75w500-fontMon">{text}</Component>;
  };


  export const MonTextS75W700 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s75w700-fontMon">{text}</Component>;
  }



  export const MonTextS14W300LH20 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s14w300lh20-fontMon">{text}</Component>;
  }

  export const MonTextS14W300LH22 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s14w300lh22-fontMon">{text}</Component>;
  }

  
  export const MonTextS14W500LH20 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s14w500lh20-fontMon">{text}</Component>;
  }
  
  export const MonTextS16W300LH26 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s16w300lh26-fontMon">{text}</Component>;
  }
  export const MonTextS16W500LH26 = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s16w500lh26-fontMon">{text}</Component>;
  }

  
  export const MonTextS15W500LH22 = ({ text, type = 'div', className = '' }: IPodTextProps) => {
    const Component = type;
    const classes = `s15w500lh22-fontMon ${className}`;
  
    return <Component className={classes.trim()}>{text}</Component>;
}
export const MonTextS18W600LH18Co111 = ({ text, type = 'div' }: IPodTextProps) => {
  const Component = type;

  return <Component className="s18w600lh18white-fontMon">{text}</Component>;
}

  export const MonTextS24W500LH32LS05Minu1C1C = ({ text, type = 'div' }: IPodTextProps) => {
    const Component = type;
  
    return <Component className="s24w500lh32ls05minus1c1c-fontMon">{text}</Component>;
  }


  export const MonTextS24W600LH32Ls05Minu = ({ text, type = 'div', className = '' }: IPodTextProps) => {
    const Component = type;
    const classes = `s24w600lh32ls05Minu-fontMon ${className}`;
  
    return <Component className={classes.trim()}>{text}</Component>;
}


